const accTitles = document.querySelectorAll(".accordion-Title");

accTitles.forEach((title) => {
  title.addEventListener("click", function () {
    const parent = this.parentNode;
    const content = parent.querySelector(".accordion-content");

    if (parent.classList.contains("active")) {
      parent.classList.remove("active");
      content.style.height = `0px`;
    } else {
      accTitles.forEach((t) => {
        const p = t.parentNode;
        const c = p.querySelector(".accordion-content");
        p.classList.remove("active");
        c.style.height = `0px`;
      });

      parent.classList.add("active");
      content.style.height = `${content.scrollHeight}px`;
    }
  });
});